import React from 'react';

const PlusIcon = () => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="plus icon">
                <path
                    id="Vector 10"
                    d="M7.95752 1.77173V13.7717"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector 11"
                    d="M13.9575 7.27173L1.95752 7.27173"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default PlusIcon;
